import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface ImagePreviewModalProps {
    isOpen: boolean;
    imageUrl: string;
    alt?: string;
    title?: string;
    onClose: () => void;
    imageClassName?: string;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
    isOpen,
    imageUrl,
    alt = '预览图片',
    title = '图片预览',
    onClose,
    imageClassName = 'rounded-[2rem]'
}) => {
    useEffect(() => {
        if (!isOpen) return;

        const previousOverflow = document.body.style.overflow;
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[90] flex items-center justify-center p-4">
            <div
                className="absolute inset-0 bg-black/72 backdrop-blur-md"
                onClick={onClose}
            />
            <div className="relative w-full max-w-3xl rounded-[2rem] border border-white/10 bg-white/6 p-4 shadow-2xl">
                <div className="mb-4 flex items-center justify-between px-1">
                    <h3 className="text-sm font-medium text-white/80">{title}</h3>
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
                        aria-label="关闭预览"
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>
                <div className="overflow-hidden rounded-[1.75rem] bg-white/10">
                    <img
                        src={imageUrl}
                        alt={alt}
                        className={`max-h-[78vh] w-full object-contain bg-black/20 ${imageClassName}`}
                    />
                </div>
            </div>
        </div>
    );
};

export default ImagePreviewModal;
